<template>
    <div>
        <div class="app-title">
            <em-view-title :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'list'">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter :entity="modelName" ref="emListFilter"
                                           $_em-custom-vuex-mixin_vo="schedulingVo"
                                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="sithMesPrdPpOperationResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table :entity="modelName" withCustomRowActions $_em-custom-vuex-mixin_vo="schedulingVo"
                                      ref="emTable" :inlineActionsDisabled="prop_inline!=='1'"
                                      @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                                      @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow">
                                <template #left-header>
                                    <em-button type="edit" custom-icon="fa fa-fw fa-lg fa-arrow-down"
                                               :disabled="setActualLoc()"
                                               custom-label="设置工位"
                                               v-bind:class="'btn btn-outline-primary btn-sm'"
                                               v-b-modal.modal-setActualLoc
                                    >
                                    </em-button>
                                    <em-button type="edit" custom-icon="fa fa-fw fa-lg fa-arrow-right"
                                               :disabled="actionDisabled('selectOne')"
                                               custom-label="调整计划开始时间"
                                               v-bind:class="'btn btn-outline-primary btn-sm'"
                                               @click="forecastBeginTimeAdjust()"
                                    >
                                    </em-button>
                                    <em-button type="check" custom-icon="fa fa-fw fa-lg fa-lock"
                                               :disabled="actionDisabled('select')"
                                               custom-label="锁定"
                                               v-bind:class="'btn btn-outline-primary btn-sm'"
                                               @click="lock()"
                                    >
                                    </em-button>
                                    <em-button type="cancel" custom-icon="fa fa-fw fa-lg fa-unlock"
                                               :disabled="actionDisabled('select')"
                                               custom-label="解锁"
                                               v-bind:class="'btn btn-outline-primary btn-sm'"
                                               @click="unlock()"
                                    >
                                    </em-button>
                                    <em-button type="save" custom-icon="fas fa-fw fa-lg fa-circle"
                                               custom-label="完工"
                                               :disabled="actionDisabled('select')"
                                               v-bind:class="'btn btn-outline-primary btn-sm'"
                                               @click="complete()"
                                               :busy="onComplete"
                                               confirm-text="确定要手动设置完工么？"
                                    >
                                    </em-button>
                                    <em-button type="edit" custom-icon="fa fa-fw fa-lg fa-truck"
                                               :disabled="actionDisabled('selectOne')"
                                               custom-label="外协转出"
                                               :showName="true"
                                               v-bind:class="'btn btn-outline-primary btn-sm'"
                                               @click="openTransDialog()"
                                    >
                                    </em-button>
                                    <em-button
                                        type="uploadFile"
                                        class="btn btn-outline-primary btn-sm"
                                        :disabled="actionDisabled('selectOne')"
                                        custom-label="上传附件"
                                        :busy="saveAttachmentLoading"
                                        @click="openAttachmentModal">
                                    </em-button>
                                    <em-button
                                        type="edit" custom-icon="fa fa-fw fa-lg fa-comment"
                                        class="btn btn-outline-primary btn-sm"
                                        :disabled="actionDisabled('select')"
                                        custom-label="获取长描述"
                                        :busy="longDescription"
                                        @click="getLongDescription">
                                    </em-button>
                                    <em-button
                                        id="popover-tools-buttons"
                                        type="search"
                                        class="btn btn-outline-primary btn-sm"
                                        custom-label="工装"
                                        show-name>
                                    </em-button>
                                    <em-button
                                        type="uploadFile"
                                        class="btn btn-outline-primary btn-sm"
                                        :disabled="actionDisabled('selectOne')"
                                        custom-label="上传程序附件"
                                        :busy="saveProgramAttachmentLoading"
                                        @click="openProgramAttachmentModal">
                                    </em-button>
                                    <b-button
                                        class="btn-size"
                                        :disabled="actionDisabled('select')"
                                        size="sm"
                                        variant="outline-primary"
                                        @click="openUpdateRiskFactor()"
                                    >
                                        批量更改风险系数
                                    </b-button>
                                  <em-button
                                      id="popover-export-buttons"
                                      type="search"
                                      v-api-permission="['%/sithMesPrdPpOperation/generateTransferTicket','edit']"
                                      class="btn btn-outline-primary btn-sm"
                                      :disabled="actionDisabled('select')"
                                      custom-label="生成转出票"
                                      :busy="generatingTransferTicket"
                                      @click="generateTransferTicket"
                                      show-name>
                                  </em-button>
                                    <b-popover target="popover-tools-buttons" triggers="hover click" placement="top">
                                        <b-button-group>
                                            <em-button
                                                type="gotoChild"
                                                class="btn btn-outline-primary btn-sm"
                                                customLabel="查看工装上挂详情"
                                                :disabled="actionDisabled('selectOne')"
                                                @click="gotoToolsRelatePage">
                                            </em-button>
                                            <em-button
                                                type="search"
                                                class="btn btn-outline-primary btn-sm"
                                                custom-icon="fa fa-link"
                                                custom-label="挂工装"
                                                :busy="relateLoading"
                                                :disabled="actionDisabled('select')"
                                                @click="openToolsSelector"
                                                show-name>
                                            </em-button>
                                            <em-button
                                                type="search"
                                                class="btn btn-outline-primary btn-sm"
                                                custom-icon="fa fa-link"
                                                custom-label="挂工装包"
                                                :busy="relateLoading"
                                                :disabled="actionDisabled('select')"
                                                @click="$refs.toolsPackageSelect.showModal()"
                                                show-name>
                                            </em-button>
                                            <em-button
                                                type="search"
                                                class="btn btn-outline-primary btn-sm"
                                                custom-label="打包工装包"
                                                custom-icon="fa fa-suitcase"
                                                :busy="packUpLoading"
                                                :disabled="actionDisabled('selectOne')"
                                                @click="$refs.packageNameInput.showModal()">
                                            </em-button>
                                            <em-button
                                                type="search"
                                                class="btn btn-outline-primary btn-sm"
                                                custom-icon="fa fa-toggle-off"
                                                custom-label="未上挂"
                                                confirm-text="确认将所选工序设置为未上挂状态吗？"
                                                :busy="relateStatusLoading"
                                                :disabled="actionDisabled('select')"
                                                @click="changeStatusToUnrelated"
                                                show-name>
                                            </em-button>
                                        </b-button-group>
                                        <b-button-group class="ml-1">
                                            <em-button
                                                type="search"
                                                class="btn btn-outline-primary btn-sm"
                                                custom-label="需上挂"
                                                confirm-text="确认将所选工序设置为需上挂标记吗？"
                                                :busy="relateNeedLoading"
                                                :disabled="actionDisabled('select')"
                                                @click="changeRelateNeedStatus(true)"
                                                show-name>
                                            </em-button>
                                            <em-button
                                                type="search"
                                                class="btn btn-outline-primary btn-sm"
                                                custom-label="不需上挂"
                                                confirm-text="确认将所选工序设置为不需上挂标记吗？"
                                                :busy="relateNeedLoading"
                                                :disabled="actionDisabled('select')"
                                                @click="changeRelateNeedStatus(false)"
                                                show-name>
                                            </em-button>
                                        </b-button-group>
                                    </b-popover>
                                    <out-operation-view></out-operation-view>
                                </template>
                                <template #customRowActions="{row}">
                                    <b-button-group>
                                        <em-button type="showEntity"
                                                   custom-label="前置依赖"
                                                   :class="'btn btn-outline-primary btn-sm'"
                                                   custom-icon="fa fa-fw fa-lg fa-link"
                                                   @click="popPod(row)">
                                        </em-button>
                                        <em-button type="gotoGrandParent"
                                                   :class="'btn btn-outline-primary btn-sm'"
                                                   @click="gotoGrandParentLevel(row)">
                                        </em-button>
                                    </b-button-group>
                                </template>
                            </em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
        <b-modal id="modal-setActualLoc" title="设置工位" hide-footer @show="getActualLocOptions">
            <b-form @submit="handleSubmit" @reset="handleReset">
                <b-form-group
                    id="actualLocId-group"
                    label="工位:"
                    label-for="input-actualLocId"
                    invalid-feedback="必须选择工位"
                >
                    <b-form-select id="input-actualLocId" v-model="saveForm.actualLocId" :options="locOptions"
                                   required></b-form-select>
                </b-form-group>
                <b-form-group
                    id="headCountState"
                    label="每班人数:"
                    label-for="input-headCountState"
                    invalid-feedback="必须填写人数"
                >
                    <b-form-input id="input-headCountState" v-model="saveForm.headCount" placeholder="请输入人数"
                                  type="number"
                                  required></b-form-input>
                </b-form-group>
                <b-row align-h="end" style="margin-top: 30px">
                    <b-button type="submit" variant="primary">保存</b-button>
                    <b-button type="reset" variant="danger">取消</b-button>
                </b-row>
            </b-form>
        </b-modal>
        <el-dialog
            :title="adjustDialogTitle"
            :center="true"
            width="30%"
            :visible.sync="adjustDialogVisible">
            <div class="col center-name dialog-text">
                <div class="row">
                    <div class="col" style="padding-left: 10%">
                        <div class="row">
                            <el-date-picker
                                class="col mt-1"
                                v-model="forecastDate"
                                type="datetime"
                                :placeholder="adjustDatePickerPlaceHolder"
                                :clearable="false"
                                :editable="false">
                            </el-date-picker>
                        </div>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
        <el-button @click="adjustDialogVisible = false">取 消</el-button>
        <el-button :loading="submitLoading" type="primary" @click="submitChange">确 定</el-button>
      </span>
        </el-dialog>
        <!-- 工序叫车 -->
        <el-dialog title="申请运输" :visible.sync="transDialogVisible" :close-on-click-modal='false' append-to-body
                   @close='clearTransForm'>
            <el-form :model="transForm" ref="transForm" label-width="auto" size="mini" :inline="true" :rules="rules">
                <el-row>
                    <el-col :span="8">
                        <el-form-item label="运输类型" prop="transType">
                            <el-select v-model="transForm.transType" placeholder="请选择">
                                <el-option v-for="item in transTypeOptions" :key="item.value" :label="item.label"
                                           :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="运输时间" prop="requiredTime">
                            <el-date-picker v-model="transForm.requiredTime" type="datetime" placeholder="选择日期时间"
                                            value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="长(mm)" prop="length">
                            <el-input v-model="transForm.length" type="number"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="8">
                        <el-form-item label="宽(mm)" prop="width">
                            <el-input v-model="transForm.width" type="number"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="高(mm)" prop="height">
                            <el-input v-model="transForm.height" type="number"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="重量(kg)" prop="weight">
                            <el-input v-model="transForm.weight" type="number"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="8">
                        <el-form-item label="转出联系人" prop="sourceContact">
                            <el-input v-model="transForm.sourceContact"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="接收人" prop="destContact">
                            <el-input v-model="transForm.destContact"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="接收人电话" prop="destPhone">
                            <el-input v-model="transForm.destPhone"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="8">
                        <el-form-item label="接收方地址" prop="destAddr">
                            <el-input v-model="transForm.destAddr"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="是否需要包装" prop="requirePackage">
                            <el-select v-model="transForm.requirePackage" placeholder="请选择">
                                <el-option v-for="item in packageOptions" :key="item.value" :label="item.label"
                                           :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="外协PR">
                            <el-input v-model="transForm.outsourcePr"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="8">
                        <el-form-item label="外协框架内/外">
                            <el-select v-model="transForm.frame" placeholder="请选择">
                                <el-option v-for="item in frameOptions" :key="item.value" :label="item.label"
                                           :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="出门类型">
                            <el-select v-model="transForm.outdoorType" placeholder="请选择">
                                <el-option v-for="item in outdoorTypeOptions" :key="item.value" :label="item.label"
                                           :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="数量" prop="quantity">
                            <el-input v-model="transForm.quantity" type="number"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="8">
                        <el-form-item label="物料描述" prop="materialDesc">
                            <el-input v-model="transForm.materialDesc" type="textarea"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="备注">
                            <el-input v-model="transForm.remark" type="textarea"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="transDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitApplication()">发起申请</el-button>
            </div>
        </el-dialog>

        <el-dialog :close-on-click-modal='false' append-to-body :visible.sync="updateRiskFactorVisible" title="批量更改风险系数"
                   width="30%" @close='clearRiskFactor'>
            <el-form>
                <el-form-item label="请输入风险系数:" label-width="auto">
                    <el-input-number :precision="0" v-model="riskFactor" :min="1" :max="200" label="风险系数"></el-input-number>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="updateRiskFactorVisible = false">取 消</el-button>
                <el-button type="primary" @click="batchUpdateRiskFactor()">确认</el-button>
            </div>
        </el-dialog>
        <sub-entity-list ref="podEntityList" sub-entity="sithMesPrdPpOperationDependencyPod"
                         parent-field="podIdOrigin"></sub-entity-list>
        <!--上传附件-->
        <ReBModal header="上传附件"
                  @ok="submitAttachmentChange"
                  ref="uploadAttachment">
            <multi-attachment class="w-100"
                              :query-api="attachmentQueryApi"
                              @loading="attachmentLoading"
                              @idsChanged="changeAttachmentIds"
                              :attachment-ids="attachmentIds"></multi-attachment>
        </ReBModal>
        <!--工装选择-->
        <em-modal-entity-selector ref="toolsSelect" check-enable need-checked-rows
                                  @checkFinish="toolsSelectFinish"></em-modal-entity-selector>
        <!--工装数量填写-->
        <ReBModal header="工装数量填写"
                  @ok="submitToolsRelate"
                  ref="toolsQuantityInput">
            <mini-table
                ref="quantityInputTable"
                read-only
                :items="toolsCheckedRows"
                :fields="toolsQuantityInputTableFields">
            </mini-table>
        </ReBModal>
        <!--工装包选择-->
        <em-modal-normal-input-entity-selector ref="toolsPackageSelect" entity="sithMesPrdToolsPackage"
                                               @entityModalSelectSelected="toolsPackageSelected"></em-modal-normal-input-entity-selector>
        <ReBModal header="输入"
                  @ok="packUpToolsRelate"
                  ref="packageNameInput">
            <diverse-input :config="packageNameInputConfig" :value.sync="toolsPackageName"></diverse-input>
        </ReBModal>

        <ReBModal header="上传附件"
                  @ok="submitProgramAttachmentChange"
                  ref="uploadProgramAttachment">
            <multi-attachment class="w-100"
                              :query-api="attachmentQueryApi"
                              @loading="attachmentLoading"
                              @idsChanged="changeAttachmentIds"
                              :attachment-ids="attachmentIds"></multi-attachment>
        </ReBModal>

    </div>
</template>
<script>
// Author YuJiaBei
// Date 2020-09-30 18:07:14

import emCommonListMixin from "@/mixin/em/common/list";
import emCommonGotoMixin from "@/mixin/em/common/goto";
import emCommonApiMixin from "@/mixin/em/common/api";
import commonViewsUtil from "@/utils/commonViewsUtil";
import subEntityList from "@/components/em/EmModal/SubEntityList"
import moment from "moment";
import ReBModal from "@/components/echarts-part/CalendarShift/cells/stuffs/ReBModal";
import MultiAttachment from "@/components/echarts-part/stuff/MultiAttachment";
import emCommonUtilMixin from "@/mixin/em/common/stuffs/utils/emCommonUtilMixin";
import MiniTable from "@/components/common/mini-table/MiniTable.vue";
import EmModalNormalInputEntitySelector from "@/components/em/EmModal/NormalInputEntitySelector";
import DiverseInput from "@/components/workflow/stuffs/DiverseInput";
import MiniButton from "@/components/common/buttons/MiniButton.vue";
import OutOperationView from "@/views/sithMes/prd/stuff/OutOperationView.vue";

export default {
    name: "sithMesPrdPpOperationListView",
    mixins: [emCommonListMixin, emCommonGotoMixin, emCommonApiMixin, emCommonUtilMixin],
    components: {
        OutOperationView,
        MiniButton,
        DiverseInput, EmModalNormalInputEntitySelector, MiniTable, MultiAttachment, ReBModal, subEntityList},
    props: {
        //是否启用行编辑
        prop_inline: {
            type: String,
            default: "0"
        }
    },
    data() {
        return {
            onScheduling: false,
            riskFactor:0,
            updateRiskFactorVisible : false,

            onSaving: false,
            onComplete: false,
            adjustDialogTitle: "",
            forecastDate: '',
            adjustDatePickerPlaceHolder: "",
            submitLoading: false,
            adjustDialogVisible: false,
            forecastLocationId: "",
            adjustType: 1,
            locOptions: [],
            saveForm: {
                actualLocId: '',
                headCount: '',
                operationIds: ''
            },
            transDialogVisible: false,
            transForm: {
                transType: '',
                requiredTime: '',
                length: '',
                width: '',
                height: '',
                weight: '',
                sourceContact: '',
                destContact: '',
                destPhone: '',
                destAddr: '',
                requirePackage: '',
                outsourcePr: '',
                frame: '',
                outdoorType: '',
                materialDesc: '',
                quantity: '',
                remark: ''
            },
            rules: {
                transType: [{required: true, message: '请选择运输类型'}],
                requiredTime: [{required: true, message: '请选择运输时间'}],
                requirePackage: [{required: true, message: '请选择是否包装'}],
                materialDesc: [{required: true, message: '请输入描述'}],
                quantity: [{required: true, message: '请输入数量'}],
            },
            transTypeOptions: [
                {
                    value: 1,
                    label: '内对外'
                }, {
                    value: 2,
                    label: '内对内'
                }, {
                    value: 3,
                    label: '汽车吊'
                }, {
                    value: 4,
                    label: '外对外'
                }, {
                    value: 5,
                    label: '外对内'
                }
            ],
            outdoorTypeOptions: [
                {value: '11', label: 'A类-非销售'},
                {value: '12', label: 'B类-销售产成品'},
                {value: '13', label: 'C类-销售非产成品'},
            ],
            packageOptions: [{
                value: false,
                label: '不需要'
            }, {
                value: true,
                label: '需要'
            }],
            frameOptions: [
                {
                    value: 1,
                    label: '框架内'
                }, {
                    value: 2,
                    label: '框架外'
                }
            ],
            attachmentIds: '',
            saveAttachmentLoading: false,
            saveProgramAttachmentLoading: false,
            longDescription: false,

            //工装
            requestToolsUrl: process.env.VUE_APP_SITHMES_PRD_URL + "/sithMesPrdToolsRelateOperation",
            toolsCheckedRows: [],
            toolsQuantityInputTableFields: [
                {key: 'code', label: '序号'},
                {key: 'name', label: '名称'},
                {key: 'size', label: '规格型号'},
                {key: 'area', label: '区域'},
                {key: 'bin', label: 'Bin位'},
                {key: '_quantity', label: '数量', isInput: true},
            ],
            relateLoading: false,
            packUpLoading: false,
            relateStatusLoading: false,
            relateNeedLoading: false,
            generatingTransferTicket: false,
            packageNameInputConfig: {
                label: '工装包名称',
                type: 'input'
            },
            toolsPackageName: ''
        }
    },
    computed: {
        modelName() {
            return this.$_emRouterHelperMixin_entityName
        },
        selectIds() {
            //这里要注意，如果filter和table使用了customVuex，这里要用checkedItems拼装首字母开头的customVuex name。不使用$refs.emTable是因为初始化时取不到，会报错
            return this.$store.state[this.modelName]["checkedItemsSchedulingVo"].join(",")
            // return this.$refs.emTable.checkedItems.join(",")
        },
        checkedItems() {
            //这里要注意，如果filter和table使用了customVuex，这里要用checkedItems拼装首字母开头的customVuex name。不使用$refs.emTable是因为初始化时取不到，会报错
            return this.$store.state[this.modelName]["checkedItemsSchedulingVo"]
            // return this.$refs.emTable.checkedItems
        },
        headerBaseUrl() {
            return `${this.$_emApiMixin_entityBaseApi("sithMesPrdPpHeader")}/`
        },
        entityBaseUrl() {
            return `${this.$_emApiMixin_entityBaseApi(this.modelName)}/`
        },
        attachmentQueryApi() {
            return `${process.env.VUE_APP_SITHMES_PRD_URL}/${this.modelName}/getAttachmentList`;
        }
    },
    methods: {
        clearRiskFactor() {
            this.riskFactor=''
        },
        openUpdateRiskFactor() {
            this.updateRiskFactorVisible = true;
        },
        batchUpdateRiskFactor() {
            let self = this;
            let url = `${this.$_emApiMixin_entityBaseApi(self.modelName)}/batchUpdateRiskFactor?ids=${this.selectIds}&riskFactor=${self.riskFactor}`
            self.$_emApiMixin_post(url, {})
                .then(response => {
                    if (response.status === 200) {
                        self.updateRiskFactorVisible = false;
                        self.$message({
                            message: "更新成功",
                            type: "success",
                        });

                        self.$refs.emListFilter.doQuery();
                    } else {
                        self.updateRiskFactorVisible = false;
                        self.$message({
                            message: "更新失败",
                            type: "error",
                        });
                    }
                })
                .finally(() => this.updateStateVisible = false)
        },
        forecastBeginTimeAdjust() {
            this.adjustDialogTitle = "调整工序计划开始时间"
            this.adjustDatePickerPlaceHolder = "计划开始时间"
            this.forecastDate = this.$store.state.sithMesPrdPpOperation['entity'].forecastBeginTime;
            this.adjustDialogVisible = true
        },
        submitChange() {
            let self = this;
            let _api = `${this.$_emApiMixin_entityBaseApi("sithMesPrdPpOperation")}/`
            let _requestBody = {}
            if (this.adjustDialogTitle === "调整工序计划开始时间") {
                _api += "/forecast-begin-time-adjust";
                _requestBody = {
                    operationId: this.$store.state.sithMesPrdPpOperation['entity'].id,
                    manualAdjustType: this.adjustType,
                    forecastBeginTime: moment(this.forecastDate).format(
                        this.$t("em.datetime.format.viewMode")
                    )
                }
            }
            // else {
            //   _api += "/forecast-finish-time-adjust";
            //   _requestBody = {
            //     headerId: this.$store.state.sithMesPrdPpHeader['entity'].id,
            //     manualAdjustType: this.adjustType,
            //     forecastFinishTime: moment(this.forecastDate).format(
            //         this.$t("em.datetime.format.viewMode")
            //     )
            //   }
            // }
            this.$_emApiMixin_post(_api, _requestBody).then(request => {
                // this.submitLoading = false;
                if (request.status === 200) {
                    self.dialogVisible = false;
                    self.$message({
                        message: '修改成功！',
                        type: 'success'
                    });
                    self.$refs.emListFilter.doQuery();
                } else {
                    self.$message({
                        message: '修改失败！',
                        type: 'error'
                    });
                }
            }).finally(() => {
                this.adjustDialogVisible = false
            })
        },
        gotoGrandParentLevel(row) {
            this.$_emGotoMixin_gotoList("sithMesPrdPpHeader", row.prdPpHeaderId ? row.prdPpHeaderId : "")
        },
        popPod(row) {
            this.$refs.podEntityList.showModal(row.id)
        },
        //设置选中的forecastLocationId,并判断设置位置的按钮是否应该禁用
        setActualLoc() {
            //1：首先要有选中的行
            if (this.$refs["emTable"] && this.$refs["emTable"].checkedItems && this.$refs["emTable"].checkedItems.length > 0) {
                //2：其次选中的所有行的forecastLocation要相同
                //通过set去重，为空的设为null
                let forecastLocationIdSet = Array.from(new Set(this.$refs["emTable"].checkedItemsRows
                    .map(m => m.forecastMstLocationId ? m.forecastMstLocationId : null)))
                console.log(forecastLocationIdSet)
                if (forecastLocationIdSet && forecastLocationIdSet.length === 1) {
                    //设置一下选中的forecastLocationId
                    this.forecastLocationId = forecastLocationIdSet[0]
                    //3：最后唯一的这个id不能是null
                    if (this.forecastLocationId) {
                        return false
                    }
                }
            }
            return true
        },
        getActualLocOptions() {
            this.$_emApiMixin_findByFilter("sithMesMstLocation", {parentIdFilter: this.forecastLocationId})
                .then(data => {
                    this.locOptions = data.map(m => {
                        return {value: m.id, text: m.name};
                    })
                })
        },
        handleSubmit(event) {
            event.preventDefault()
            // alert(JSON.stringify(this.saveForm))
            //给选中记录id赋值
            this.saveForm.operationIds = this.selectIds
            //调用api保存数据
            //todo 调用api保存数据
            // Hide the modal manually
            this.$_emApiMixin_post(`${this.$_emApiMixin_entityBaseApi(this.modelName)}/setActualLoc`, this.saveForm)
                .then(response => {
                    commonViewsUtil.showSuccess(this, "设置成功")
                    this.$refs.emListFilter.doQuery()
                })
            this.$nextTick(() => {
                this.$bvModal.hide('modal-setActualLoc')
            })
        },
        handleReset() {
            // Reset saveForm values
            this.saveForm.actualLocId = ''
            this.saveForm.headCount = ''
            this.saveForm.operationIds = ''
            // Hide the modal manually
            this.$nextTick(() => {
                this.$bvModal.hide('modal-setActualLoc')
            })
        },
        actionDisabled(type) {
            // 删除按钮在一条记录都没选的时候禁用
            if (type === "select") {
                // return this.$refs.emTable.checkedItems && this.$refs.emTable.checkedItems.length === 0;
                return this.checkedItems && this.checkedItems.length === 0;
            }
            // 编辑按钮只在选择了1条记录的时候可用，其他情况下禁用
            else if (type === "selectOne") {
                // return this.$refs.emTable.checkedItems && this.$refs.emTable.checkedItems.length !== 1;
                return this.checkedItems && this.checkedItems.length !== 1;
            }
        },
        scheduling() {
            this.onScheduling = true
            let url = `${this.headerBaseUrl}scheduling`
            //这里是工序，所以就不传参数了，这里点击排产，代表不添加新工单，就只是重排现有排产结果
            this.$_emApiMixin_post(url, {headerIds: ''})
                .then(response => {
                    // commonViewsUtil.showSuccess(this, "排产成功")
                    // this.$refs.emListFilter.doQuery()
                    this.$store.dispatch('calendarShift/collectOriginData', response.data).then(() =>
                        this.$router.push({
                            path: "/loadRate?showSave=true"
                        })
                    )

                }).then(() => {
                this.$_emCommonListMixin_needToRefresh = true
            }).finally(() => this.onScheduling = false)

        },
        saveScheduledResult() {
            this.onSaving = true
            let url = `${this.headerBaseUrl}saveScheduledResult?version=1`
            //todo:暂时固定传1，将来再看怎么弄
            this.$_emApiMixin_post(url,)
                .then(response => {
                    commonViewsUtil.showSuccess(this, "保存成功")
                    this.$refs.emListFilter.doQuery()
                    this.$store.commit('calendarShift/setSaveResult', false);
                }).then(
                this.$_emCommonListMixin_needToRefresh = true
            ).finally(() => this.onSaving = false)
        },
        lock() {
            let url = `${this.$_emApiMixin_entityBaseApi(this.modelName)}/lock?ids=${this.selectIds}`
            console.log(this.selectIds)
            this.$_emApiMixin_post(url, {})
                .then(response => {
                    commonViewsUtil.showSuccess(this, "锁定成功")
                    this.$refs.emListFilter.doQuery()
                })

        },
        unlock() {
            let url = `${this.$_emApiMixin_entityBaseApi(this.modelName)}/unlock?ids=${this.selectIds}`
            this.$_emApiMixin_post(url, {})
                .then(response => {
                    commonViewsUtil.showSuccess(this, "解锁成功")
                    this.$refs.emListFilter.doQuery()
                })
        },
        complete() {
            this.onComplete = true
            let url = `${this.$_emApiMixin_entityBaseApi(this.modelName)}/complete?ids=${this.selectIds}`
            this.$_emApiMixin_post(url, {})
                .then(response => {
                    commonViewsUtil.showSuccess(this, "设置完工成功")
                    this.$refs.emListFilter.doQuery()
                }).finally(() => this.onComplete = false)
        },
        openTransDialog() {
            let row = this.$refs.emTable.rows.filter(r => {
                return r.id == this.checkedItems
            });
            this.transForm.materialDesc = row[0].materialDescription;
            this.transForm.quantity = row[0].operationQuantity;
            this.transForm.outsourcePr = row[0].prNumber;
            this.transDialogVisible = true;
        },
        clearTransForm() {
            this.transForm.transType = ''
            this.transForm.requiredTime = ''
            this.transForm.length = ''
            this.transForm.width = ''
            this.transForm.height = ''
            this.transForm.weight = ''
            this.transForm.sourceContact = ''
            this.transForm.destContact = ''
            this.transForm.destPhone = ''
            this.transForm.destAddr = ''
            this.transForm.requirePackage = ''
            this.transForm.remark = '',
                this.transForm.outsourcePr = '',
                this.transForm.frame = '',
                this.transForm.materialDesc = '',
                this.transForm.quantity = '',
                this.$refs["transForm"].resetFields();
        },
        submitApplication() {
            let self = this;
            self.$refs["transForm"].validate(valid => {
                if (valid) {
                    let url = `${this.$_emApiMixin_entityBaseApi("sithMesInventoryTransportApplication")}/submitTransportApplication?id=${this.selectIds}`;
                    self.$_emApiMixin_post(url, self.transForm)
                        .then((request) => {
                            if (request.status === 200) {
                                self.$message({
                                    message: "提交成功",
                                    type: "success",
                                });

                            } else {
                                self.$message({
                                    message: "提交失败",
                                    type: "error",
                                });
                            }
                        }).finally(() => {
                        this.transDialogVisible = false;
                    })
                } else {
                    self.$message({
                        message: "数据不完整",
                        type: "error",
                    });
                    return;
                }
            })

        },
        openAttachmentModal() {
            this.attachmentIds = this.$store.state.sithMesPrdPpOperation['entity'].attachments;
            console.log('attachmentIds', this.attachmentIds);
            this.$refs.uploadAttachment.showModal();
        },
        openProgramAttachmentModal() {
            this.attachmentIds = this.$store.state.sithMesPrdPpOperation['entity'].attachments;
            console.log('attachmentIds', this.attachmentIds);
            this.$refs.uploadProgramAttachment.showModal();
        },
        getLongDescription() {
            this.longDescription = true
            let url = `${this.entityBaseUrl}getLongDescription?ids=${this.selectIds}`;
            this.$_emApiMixin_post(url, {})
                .then(() => {
                    this.$_emCommonListMixin_needToRefresh = true
                }).finally(() => this.longDescription = false)
        },
        changeAttachmentIds(ids) {
            this.attachmentIds = ids;
        },
        submitAttachmentChange() {
            let checkedItem = this.checkedItems[0];
            this.saveAttachmentLoading = true;
            let api = process.env.VUE_APP_SITHMES_PRD_URL + "/" + this.modelName + "/upload/attachment";
            this.$_emApiMixin_put(api, {
                id: checkedItem,
                attachments: this.attachmentIds === undefined ? "" : this.attachmentIds
            }).then(() => {
                this.$message.success("保存成功");
                this.$refs.emListFilter.doQuery();
            }).finally(() => this.saveAttachmentLoading = false);
        },
        submitProgramAttachmentChange() {
            let checkedItem = this.checkedItems[0];
            this.saveProgramAttachmentLoading = true;
            let api = process.env.VUE_APP_SITHMES_PRD_URL + "/" + this.modelName + "/upload/attachment";
            this.$_emApiMixin_put(api, {
                id: checkedItem,
                programAttachments: this.attachmentIds === undefined ? "" : this.attachmentIds
            }).then(() => {
                this.$message.success("保存成功");
                this.$refs.emListFilter.doQuery();
            }).finally(() => this.saveProgramAttachmentLoading = false);
        },
        attachmentLoading(val) {
            this.$refs.uploadAttachment.changeLoading(val);
        },
        /*----------------工装----------------*/
        //跳转工装上挂页面
        gotoToolsRelatePage() {
            let seq = this.$refs.emTable.checkedItemsRows[0].operationSeq;
            this.$_emGotoMixin_gotoHolderList("sithMesPrdToolsRelateOperation"
                , {operationIdFilter: this.selectIds, operationSeqFilter: seq}
                , {operationId: this.selectIds, operationSeq: seq}, false, {});

        },
        //打开工装选择
        openToolsSelector() {
            this.$refs.toolsSelect.setCustomVuexConfig('sithMesPrdToolsInfo');
            this.$refs.toolsSelect.onlyShowModal();
        },
        //打开工装数量填写
        toolsSelectFinish(toolsRows) {
            if (this.hasCode(this.selectIds) && this.hasCode(toolsRows) && toolsRows.length > 0) {
                this.toolsCheckedRows = toolsRows;
                this.$refs.toolsQuantityInput.showModal();
            }
        },
        //提交工装上挂
        submitToolsRelate() {
            let saveData = this.$refs.quantityInputTable.columnEditData();
            let tempList = [];
            saveData.forEach(o => {
                let val = o._quantity;
                if (this.hasCode(val)) {
                    tempList.push({
                        toolsId: o.id,
                        quantity: Number.parseInt(val)
                    });
                }
            })
            if (tempList.length > 0) {
                this.submitRelate('tools', {
                    operationIds: this.$refs.emTable.checkedItems,
                    toolsList: tempList
                });
            }
        },
        //上挂工装包
        toolsPackageSelected(row) {
            if (this.hasCode(this.selectIds)) {
                this.submitRelate('package', {
                    operationIds: this.$refs.emTable.checkedItems,
                    packageId: row.id
                });
            }
        },
        //private function: do submit
        submitRelate(type, data) {
            this.simplePostWithLoading('relateLoading', {
                url: this.requestToolsUrl + "/relateOperation/" + type,
                data: data
            }, true);
        },
        //private function: do post
        simplePostWithLoading(loadingName, payload, needFresh) {
            this[loadingName] = true;
            this.$store.dispatch('api/post', payload).then(() => {
                this.$message.success("操作成功");
                if (needFresh) {
                    this.$refs.emListFilter.doQuery();
                }
            })
                .finally(() => this[loadingName] = false);
        },
        //打包工装包
        packUpToolsRelate() {
            if (this.hasCode(this.toolsPackageName)) {
                this.simplePostWithLoading('packUpLoading', {
                    url: `${this.requestToolsUrl}/packUp?id=${this.selectIds}&packageName=${this.toolsPackageName}`,
                    data: {}
                });
            }
        },
        //设置未上挂
        changeStatusToUnrelated() {
            this.simplePostWithLoading('relateStatusLoading', {
                url: this.requestToolsUrl + "/changeOperation/unrelated?ids=" + this.selectIds,
                data: {}
            }, true);
        },
        //设置需不需上挂
        changeRelateNeedStatus(isNeed) {
            this.simplePostWithLoading('relateNeedLoading', {
                url: this.requestToolsUrl + "/changeOperation/needRelate?ids=" + this.selectIds + "&isNeed=" + isNeed,
                data: {}
            }, true);
        },
      generateTransferTicket() {
        this.generatingTransferTicket = true;
        let self = this;
        let url = `${this.$_emApiMixin_entityBaseApi(self.modelName)}/generateTransferTicket?ids=${this.selectIds}`
        self.$_emApiMixin_post(url, {})
            .then(response => {
              if (response.status === 200) {
                self.$message({
                  message: "正在生成转出（入）票，请等待",
                  type: "success",
                });
              } else {
                self.$message({
                  message: "生成转出（入）票失败：" + response.message,
                  type: "error",
                });
              }
            })
            .finally(() => this.generatingTransferTicket = false)
      }
    },
    mounted() {
        //2023-12-20 fix: 监听了全局的modal弹出事件，改用@show触发
        // //监听modal的show事件
        // this.$root.$on('bv::modal::show', (bvEvent, modalId) => {
        //     console.log('Modal is about to be shown', bvEvent, modalId)
        //     if (modalId === "modal-setActualLoc") {
        //         this.getActualLocOptions()
        //     }
        // })
        if (this.$route.query.orderCode) {
            this.$refs.emListFilter.$_emCustomVuexMixin_setFilterAttribute('orderCodeFilter', this.$route.query.orderCode);
        } else
            //从邮件或小铃铛的外协到货通知跳转到工序
        if (this.$route.query.orderNumber) {
            this.$refs.emListFilter.$_emCustomVuexMixin_setFilterAttribute('orderCodeFilter', this.$route.query.orderNumber);
        }
        this.$refs["emListFilter"].doQuery();
    }
};
</script>
